import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import submitForm from './helpers/submitForm';
import { useDispatch, useSelector } from 'react-redux';

const handleDeleteClick = (e, deleteSingleUpload, deliveryId) => {
  e.stopPropagation();
  if (window.confirm("Vill du verkligen radera denna leverans?")) {
    deleteSingleUpload(deliveryId);
  }
}

const CustomerGdprForm = ({ deleteSingleUpload, deliveryId, s, initialValues }) => {
  const dispatch = useDispatch();
  const uploadData = useSelector(state => state.Admin.data.upload.data);

  const { handleSubmit, control, formState: { errors } } = useForm({
    defaultValues: initialValues?.gdpr || {
      origin: '',
      purpose: '',
      noOfEntities: '',
      type: '',
      description: ''
    }
  });

  const onSubmit = (data) => {
    submitForm({ gdpr: data }, dispatch, uploadData);
  };

  const required = (value) => value ? undefined : 'Detta fält är obligatoriskt';

  const renderField = ({ field, label, placeholder, helpText, type = 'input', rows, disabled, error }) => (
    <div className="form-group">
      <label className="control-label">{label}</label>
      <div>
        {type === 'textarea' ? (
          <textarea
            {...field}
            className={`form-control textarea--no-resize ${error ? 'is-invalid' : ''}`}
            placeholder={placeholder}
            rows={rows}
            disabled={disabled}
          />
        ) : (
          <input
            {...field}
            type="text"
            className={`form-control ${error ? 'is-invalid' : ''}`}
            placeholder={placeholder}
            disabled={disabled}
          />
        )}
        {helpText && <small className="form-text text-muted">{helpText}</small>}
        {error && <div className="invalid-feedback d-block">{error.message}</div>}
      </div>
    </div>
  );

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={s["form-section"]}>
          <Controller
            name="origin"
            control={control}
            rules={{ validate: required }}
            render={({ field, fieldState }) => renderField({
              field,
              label: "Ursprung",
              placeholder: "Ex: Eget kundregister",
              helpText: "Beskriv vart fil(erna) kommer från",
              disabled: true,
              error: fieldState.error
            })}
          />
          <Controller
            name="purpose"
            control={control}
            rules={{ validate: required }}
            render={({ field, fieldState }) => renderField({
              field,
              label: "Syfte",
              placeholder: "Ex: Ska ringa kunder och behöver telefonnummer",
              helpText: "Beskriv vad ni ska göra med den slutgiltiga leveransen",
              error: fieldState.error
            })}
          />
          <Controller
            name="noOfEntities"
            control={control}
            rules={{ validate: required }}
            render={({ field, fieldState }) => renderField({
              field,
              label: "Antal poster",
              placeholder: "Ex: ca 4500st",
              helpText: "Beskriv ungefär hur många poster fil(erna) ni skickar innehåller",
              error: fieldState.error
            })}
          />
          <Controller
            name="type"
            control={control}
            rules={{ validate: required }}
            render={({ field, fieldState }) => renderField({
              field,
              label: "Typ av uppgift",
              placeholder: "Ex: personnummer och namn",
              helpText: "Beskriv vad för typ av personuppgifter filen innehåller.",
              error: fieldState.error
            })}
          />
          <Controller
            name="description"
            control={control}
            rules={{ validate: required }}
            render={({ field, fieldState }) => renderField({
              field,
              label: "Uppdragsbeskrivning",
              placeholder: "Vad vill du att vi ska göra med filerna?",
              helpText: "Beskriv vad ni önskar att vi ska göra med fil(erna) ni skickar in",
              type: "textarea",
              rows: 4,
              error: fieldState.error
            })}
          />
        </div>
        <div className={s["collapse__footer"]}>
          <button type="submit" className="btn btn--primary">Spara beskrivning</button>
          <button type="button" className="btn btn--danger" onClick={(e) => handleDeleteClick(e, deleteSingleUpload, deliveryId)}>
            Förkasta hela sändningen
          </button>
        </div>
      </form>
    </div>
  );
};

export default CustomerGdprForm;